import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
export const edgeResizeStyleOf = (edgeResize)=>edgeResize == null ? {} : _object_spread({
        '--pane-width': "".concat(edgeResize.width, "px")
    }, edgeResize.isResizing && {
        transition: 'none'
    });
